import React, { FC, ReactElement, useEffect, useState } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Input } from '@ui';
type CustomDatePickerPropsType = {
  intervalPicker?: boolean;
  maxDate?: Date;
  minDate?: Date;
  customInput?: ReactElement;
  disabled?: boolean;
  withoutDefault?: boolean;
  isFull?: boolean;
  isFit?: boolean;
  isFullCustom?: boolean;
  onChange?(date: string): void;
  onChangeInterval?: ({ start, end }: { start: string; end: string }) => void;
  inputClassName?: string;
  selected?: Date;
  endDate?: Date;
  dataId?: string;
};
const CustomDatePicker: FC<CustomDatePickerPropsType> = (props) => {
  const {
    intervalPicker = false,
    maxDate,
    onChange,
    minDate,
    isFullCustom,
    isFull,
    customInput,
    // disabled = false,
    withoutDefault = false,
    inputClassName,
    selected,
    dataId,
    isFit,
    endDate: endDateFromProps,
    onChangeInterval,
  } = props;
  const [startDate, setStartDate] = useState(
    !withoutDefault ? selected || moment().toDate() : null,
  );
  const [endDate, setEndDate] = useState(endDateFromProps || null);
  const [inputDateValue, changeInputDateValue] = useState(
    !withoutDefault
      ? moment(selected).format('DD.MM.yyyy') || moment().format('DD.MM.yyyy') || ''
      : undefined,
  );
  const onChangePicker = (dates) => {
    intervalPicker ? onIntervalChangeHandler(dates) : onOneDateChange(dates);
  };
  function onIntervalChangeHandler(dates) {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (!start || !end) return;
    onChangeInterval && onChangeInterval({ start, end });
  }
  function onOneDateChange(dates) {
    setStartDate(dates);
    const date = moment(dates).format('DD.MM.yyyy');
    changeInputDateValue(date);
    onChange && onChange(date);
  }
  function getInputDefaultValue() {
    return intervalPicker
      ? `${startDate ? moment(startDate).format('DD.MM.yyyy') : ''} ${
          endDate ? '- ' + moment(endDate).format('DD.MM.yyyy') : ''
        }`
      : String(moment(startDate).format('DD.MM.yyyy'));
  }
  const rangeDateProps = intervalPicker && {
    startDate: startDate,
    endDate: endDate,
    selectsRange: true,
  };
  const inputProps = {
    // disabled: disabled,
    dataId: dataId,
    // datePickerMode: !disabled,
  };

  useEffect(() => {
    if (inputDateValue?.replace(/[_.]/g, '').length === 8) {
      if (moment(inputDateValue, 'DD.MM.yyyy').isValid())
        setStartDate(moment(inputDateValue, 'DD.MM.yyyy').toDate());
    } else return;
  }, [inputDateValue]);

  useEffect(() => {
    if (!selected) return;
    setStartDate(selected);
    changeInputDateValue(moment(selected).format('DD.MM.yyyy'));
  }, [selected]);
  return (
    <div className={`${isFullCustom ? 'w-full' : ''}`}>
      <DatePicker
        {...rangeDateProps}
        showYearDropdown
        showMonthDropdown
        showDisabledMonthNavigation
        dropdownMode="select"
        onChange={onChangePicker}
        selected={startDate}
        maxDate={maxDate}
        minDate={minDate}
        customInput={
          customInput ? (
            customInput
          ) : (
            <div
              className={`flex items-center ${isFull ? 'w-full' : isFit ? 'w-fit' : 'w-[214px]'} ${
                inputClassName || ''
              }`}
            >
              {intervalPicker ? (
                <Input
                  {...inputProps}
                  autoComplete={'off'}
                  name="dateStart"
                  icon="CalendarEmptyIcon"
                  defaultValue={getInputDefaultValue()}
                  mask="99.99.9999 - 99.99.9999"
                />
              ) : (
                <Input
                  {...inputProps}
                  mask="99.99.9999"
                  autoComplete={'off'}
                  name="dateStart"
                  icon="CalendarEmptyIcon"
                  onChange={(event) => changeInputDateValue(event.target.value)}
                  defaultValue={inputDateValue}
                  error={
                    inputDateValue
                      ? inputDateValue?.replace(/[_.]/g, '').length !== 8 ||
                        !moment(inputDateValue, 'DD.MM.yyyy').isValid()
                        ? ' '
                        : ''
                      : inputDateValue
                  }
                />
              )}
            </div>
          )
        }
      />
    </div>
  );
};

export default CustomDatePicker;
